<content-panel #panel [itemsCount]="totalCount" [hidden]="docId && docId != impacterId"
               [loading]="currentRequest && !currentRequest.closed" >
  <ng-template contentPlaceholder>
    <div class="content-state">
      <img src="/assets/images/articles-placeholder-icon.svg" alt="placeholder-icon" width="120" height="120">
      <div class="state-title">{{'search-placeholder.articles.title' | translate}}</div>
      <div class="state-subtitle">
        <div><span class="fw-bold">
          {{nbTotalArticle?.toLocaleString()}}</span> {{'search-placeholder.articles.articles' | translate}}
        </div>
        <div><span class="fw-bold">
          {{nbTotalSource?.toLocaleString()}}</span> {{'search-placeholder.articles.newspapers' | translate}}
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template contentList [items]="articles" [headerTemplate]="headerTemplate" [itemTemplate]="itemTemplate">
  </ng-template>
  <ng-template contentFooter>
    @if (nbPages > 1) {
      <app-pagination [nbPages]="nbPages" [stats]="dataUpdated" [inImpacterView]="!!impacterId"></app-pagination>
    }
  </ng-template>
  <ng-template contentLoading>
    <div class="content-loading">
      <ex-overlay-loader direction="column" color="secondary" [text]="'search.loading' | translate"></ex-overlay-loader>
    </div>
  </ng-template>
  <ng-template contentEmpty>
    <div class="content-state">
      <mat-icon svgIcon="close-circle-fill"></mat-icon>
      <div class="state-title">{{'content.no-result-message' | translate}}</div>
      <div class="state-subtitle">
        {{'content.indicative-no-result-message' | translate}}
      </div>
    </div>
  </ng-template>
</content-panel>
<section [hidden]="!docId || (impacterId === docId)">
  <router-outlet></router-outlet>
</section>

<ng-template #headerTemplate>
  <div class="results-header">
    <div class="flex-1">
      <div class="results-title">
        {{ (totalCount == 10000 ? 'search.more-than' : "") | translate }}
        {{ totalCount?.toLocaleString() }}
        {{ (totalCount && totalCount > 1 ? 'search.results' : 'search.result') | translate }}
      </div>
      <div class="results-subtitle">
        @if (impacterId) {
          <span>
            {{ (impacterArticlesCount > 1 ? 'search.article-results' : 'search.article-result')
              | translate: {totalCount: impacterArticlesCount.toLocaleString()} }}
          </span>
        } @else {
          <span>
            {{ (articlesCount > 1 ? 'search.article-results' : 'search.article-result')
              | translate: {totalCount: articlesCount.toLocaleString()} }}
            {{ (sourcesCount > 1 ? 'search.article-sub-results' : 'search.article-sub-result')
              | translate: {nbWebsite: sourcesCount.toLocaleString()} }}
          </span>
          <i class="ph ph-info"
             [ngbTooltip]="sources"
             tooltipClass="custom-tooltip-sources"
             placement="bottom auto"
          ></i>
        }
      </div>
    </div>
    <ex-button type="ai" variant="tonal" size="medium" class="align-items-center"
               (click)="smartSearchService.openSmartSearchModal({ impacterId: impacterId})">
      <div class="d-flex align-items-center gap-1">
        <mat-icon svgIcon="sparks-filled" class="icon-20"></mat-icon>
        <span> {{ "search.smart-search-button" | translate }} </span>
      </div>
    </ex-button>
  </div>
</ng-template>
<ng-template #itemTemplate let-item>
  <app-article-card
    data-cy="article-card"
    [bookmarkPaths]="item.bookmarkPaths"
    [docId]="item.id"
    [title]="item.title"
    [publicationDate]="item.publicationDate"
    [source]="item.source"
    [nbOccurrences]="item.occurrenceCount"
    [text]="item.excerpt?.[0]"
    [territories]="item.territories"
    [photoCount]="item.html?.nbImages"
    [impacterId]="impacterId"
  />
</ng-template>
<ng-template #sources>
  <ul class="sources-list" >
    <li *ngFor="let source of sourcesList" class="source">{{source}}</li>
  </ul>
</ng-template>
